// #/services/workspaces/createWorkspaceFromTemplate.ts

import { IWorkspace } from '#/types/workspace';
import getNewWorkspace from './getNewWorkspace';

export async function newWorkspaceFromTemplate(args: {
  template: IWorkspace;
  newOwnerAddress: string;
}) {
  const { template, newOwnerAddress } = args;
  const newWorkspace = {
    ...(await getNewWorkspace({
      ownerAddress: newOwnerAddress,
      workspaceName: template.name,
      workspaceDescription: template.description,
      workspaceIcons: template.icons,
    })),
    name: template.name,
    description: template.description,
    icons: template.icons,
    nodes: template.nodes,
    edges: template.edges,
    context: template.context,
  };
  return newWorkspace;
}

export default newWorkspaceFromTemplate;
